import React, { useState } from "react";
import {
  Grid,
  Typography,
  FormGroup,
  FormControlLabel,
  Switch,
  Box,
  Tooltip,
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import useCache from "../../app/useCache";
import { CachedEntity, CacheLookup } from "../../app/cacheSlice";
import {
  createUserApplicationRelation,
  deleteUserApplicationRelation,
  UserApplicationRequest,
} from "../../app/userSlice";
import { useCurrentUser } from "../../app/useCurrentUser";
import { SnackDisplay } from "@lp/lp-ui";

export default function UserApplicationsPanel() {
  const dispatch = useAppDispatch();
  const userState = useAppSelector((store) => store.user);
  const applications = useCache(CachedEntity.Application);
  const [snackMessage, setSnackMessage] = useState("");
  const [isAdmin, ,] = useCurrentUser();

  const handleUserApplicationChange = (applicationCache: CacheLookup, enabled: boolean) => {
    const request: UserApplicationRequest = {
      userId: userState.id,
      application: {
          id: applicationCache.id,
          clientId: applicationCache.key,
          clientName: applicationCache.label,
          description: applicationCache.description,
          clientUri: "",
          logoUri: ""
      }
    };
    if (enabled) {
      dispatch(createUserApplicationRelation(request));
    } else {
      dispatch(deleteUserApplicationRelation(request));
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5" color="primary">
            Applications
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {applications.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              No applications available.
            </Typography>
          )}
          <FormGroup>
            {applications.map((application) => (
              <Box key={application.key} mb={1}>
                <FormControlLabel
                  key={`applications.${application.id}`}
                  control={
                    <Switch
                      name={`applications.${application.id}`}
                      checked={userState?.applications.some(
                        (ua) => ua.id === application.id
                      )}
                      onChange={(_, checked) =>
                        handleUserApplicationChange(application, checked)
                      }
                      disabled={!isAdmin || !userState?.data?.enabled}
                    />
                  }
                  label={
                    <Box display="flex" alignItems="center">
                        {application.label ? application.label : application.key}
                        <Tooltip title={application.description} placement="right">
                            <InfoIcon color="inherit" fontSize="small" sx={{ ml: 0.5 }} />
                        </Tooltip>
                    </Box>
                  }
                />
              </Box>
            ))}
          </FormGroup>
        </Grid>
      </Grid>
      {snackMessage && (
        <SnackDisplay
          snack={snackMessage}
          handleClose={() => setSnackMessage("")}
        />
      )}
    </React.Fragment>
  );
}
